<template>
  <el-dialog
    :visible.sync="visible"
    :title="'选择模版内容'"
    append-to-body
    @close="handleDialogClose"
    width="80%"
  >
    <div class="body-wrap">
      <!-- 搜索 -->
      <div class="search-wrap" >
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-cascader
          size="mini"
          v-model="form.category_id"
          :options="category_list"
          :props="{
              label: 'name',
              value: 'id',
              children: 'children',
              checkStrictly: true,
              emitPath: false
            }"
          placeholder="请选模版分类"
          clearable
        >
          <template slot-scope="{ data }">
            <span>{{ data.name }}</span>
          </template>
        </el-cascader>
        <el-select size="mini" v-model="form.aging_type" filterable clearable placeholder="请选择账龄类型">
          <el-option
            v-for="item in aging_type"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
<!--        <el-select size="mini" v-model="form.arrears_type" filterable clearable placeholder="请选择欠费类型">-->
<!--          <el-option-->
<!--            v-for="item in arrears_type"-->
<!--            :key="item"-->
<!--            :label="item"-->
<!--            :value="item"-->
<!--          />-->
<!--        </el-select>-->
        <el-select size="mini" v-model="form.payment_type" filterable clearable placeholder="请选择缴费周期">
          <el-option
            v-for="item in payment_type"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-button size="mini" type="primary" @click="getList(1)" :loading="searchLoading">搜索</el-button>
      </div>

      <!-- 数据列表 -->
      <div class="table-wrap" >
        <el-table border v-loading="searchLoading" :data="tableData" row-key="id">
          <el-table-column prop="name" label="模版名称" align="center"></el-table-column>
          <el-table-column prop="category.name" label="分类名称" align="center"></el-table-column>
          <el-table-column prop="aging_type" label="账龄类型" align="center"></el-table-column>
<!--          <el-table-column prop="arrears_type" label="欠费类型" align="center"></el-table-column>-->
          <el-table-column prop="payment_type" label="缴费周期" align="center"></el-table-column>
          <el-table-column prop="department_name" label="所属项目" align="center"></el-table-column>
          <el-table-column prop="description" label="模版说明" align="center"></el-table-column>
          <el-table-column label="模版内容" align="center">
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover" title="模版内容" :content="scope.row.content">
                <el-button slot="reference" size="mini">查看</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="selectTemplate(scope.row)">选择该模版</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          size="mini"
          background
          @current-change="getList"
          :current-page.sync="page"
          :page-size="pageSize"
          :total="total"
          layout="total, prev, pager, next"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ProjectCollectionTemplate",
  data(){
    return{
      keyword: '',
      form: {},
      searchLoading:  false,
      visible:  false,
      page: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      aging_type: [],
      arrears_type: [],
      category_list: [],
      payment_type: [],
    }
  },
  mounted() {
    this.getCategory()
    this.getAgingType()
    this.getArrearsType()
    this.getPaymentType()
    this.getList()
  },
  methods:{
    getList(p) {
      if(p)this.page = p
      var params = this.form
      params.page = this.page
      params.page_size = this.pageSize
      params.keyword = this.keyword
      this.$myhttp.get('butler/ProjectCollectionTemplate/getList', {params: params}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    getCategory(p) {
      if(p)this.page = p
      this.$myhttp.get('butler/ProjectCollectionTemplateCategory/getList', {}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.category_list = res.data.list
        }
      })
    },
    getAgingType() {
      this.$myhttp.get('butler/ProjectCollectionTemplate/get_aging_type', {}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.aging_type = res.data
        }
      })
    },
    getArrearsType() {
      this.$myhttp.get('butler/ProjectCollectionTemplate/get_arrears_type', {}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.arrears_type = res.data
        }
      })
    },
    getPaymentType() {
      this.$myhttp.get('butler/ProjectCollectionTemplate/get_payment_type', {}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.payment_type = res.data
        }
      })
    },
    openSaveDialog(data) {
      this.$refs.saveRef.show(data)
    },
    show() {
      this.visible = true
    },
    handleDialogClose() {
      this.visible = false
    },
    selectTemplate(row) {
      this.$emit('selectCurTemplate', row)
      this.handleDialogClose()
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../../common.scss';

.body-wrap {
  padding: 10px;
}

.search-wrap {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

::v-deep .el-dialog .el-dialog__body {
  padding: 0 10px;
}

.pagination-wrap {
  display: flex;
  justify-content: end;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/projectCollectionTemplate/template/select.vue